import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  const statusStyle =
    comic.status === '连载中'
      ? 'bg-accent-500 text-white'
      : comic.status === '已完结'
      ? 'bg-secondary-500 text-white'
      : 'bg-primary-500 text-white';

  return (
    <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} 韩国漫画封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className={`absolute left-2 top-2 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${statusStyle}`}>
          {comic.status}
        </span>
        {comic.hot && (
          <span className="absolute right-2 top-2 rounded-full bg-primary-500/90 px-2.5 py-1 text-xs font-medium text-white">
            热门
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/70 to-transparent px-3 pb-2 pt-8">
          <span className="flex items-center gap-1 text-xs text-white">
            <i className="ri-eye-line"></i>
            {comic.views}
          </span>
          <span className="flex items-center gap-1 text-xs text-secondary-300">
            <i className="ri-star-fill"></i>
            {comic.rating.toFixed(1)}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="truncate text-sm font-semibold text-foreground-900 md:text-base">{comic.title}</h3>
        <p className="mt-1 line-clamp-2 min-h-[2.4em] text-xs leading-relaxed text-foreground-600 md:text-sm">{comic.tagline}</p>
        <div className="mt-3 flex items-center justify-between">
          <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">{comic.genre}</span>
          <span className="whitespace-nowrap text-xs text-foreground-500">{comic.chapter}</span>
        </div>
        <div className="mt-3 flex items-center gap-2">
          <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
            <div className={`h-full rounded-full ${comic.color}`} style={{ width: `${comic.progress}%` }}></div>
          </div>
          <span className="whitespace-nowrap text-xs text-foreground-500">{comic.progress}%</span>
        </div>
      </div>
    </article>
  );
}